export function melee() {
    return {
        contrast: 0,
        delay: 0,
        elevation: 1000,
        isWait: false,
        opacity: 1,
        playbackRate: 1,
        repeat: 1,
        repeatDelay: 250,
        saturate: 0,
        size: 1,
        tint: false,
        tintColor: "#FFFFFF",
        zIndex: 1,
    }
}

/**
 * @typedef {object} DataMeleeOptions
 * 
 * @property {number}      delay -
 *
 * @property {number}      elevation -
 *
 * @property {boolean}     isWait -
 *
 * @property {number}      opacity -
 *
 * @property {number}      playbackRate -
 * 
 * @property {number}      repeat -
 *
 * @property {number}      repeatDelay -
 *
 * @property {number}      size -
 *
 * @property {number}      zIndex -
 */
